import Joi from "joi";

export type EmailVerificationSentResponseDto = { verificationSent: boolean };
export const emailVerificationSentResponseSchema =
  Joi.object<EmailVerificationSentResponseDto>({
    verificationSent: Joi.boolean().required(),
  }).unknown();
